module.exports = __webpack_public_path__ + "b4e745305304fc032dfd1b6e3ee20077.gif";